module.exports = __webpack_public_path__ + "static/media/fb-partners.630d18b8.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fb-partners.png
// module id = 117
// module chunks = 0